import Auth from "../pages/auth";
import React from "react";
import { Outlet, Route, Routes, Navigate } from "react-router-dom";
import SideMenu from "components/sideMenu/SideMenu";
import DashboardHeader from "components/dashboardHeader/DashboardHeader";
import ResetPassword from "pages/auth/resetPassword/ResetPassword";
import ChangePassword from "pages/changePassword/ChangePassword";
import { toastMessage } from "utils/toastMessage";
import { routes } from "./routes";
import { getToken } from "config/axiosInstance";

const Routing = () => {
  const DashboardRoutes = () => {
    return (
      <>
        <section className="dashboard_section">
          <div className="sidebar_section">
            <SideMenu />
          </div>
          <div className="main_content">
            <DashboardHeader />
            <div className="dashboard_content">
              <Outlet />
            </div>
          </div>
        </section>
      </>
    );
  };

  const ProtectedRoute = ({ children }) => {
    if (!getToken()) {
      return (
        <>
          <Navigate to="/" replace />
        </>
      );
    } else {
      return children;
    }
  };

  return (
    <>
      <Routes>
        <Route key={201} path="/" element={<Auth />} />
        <Route
          key={301}
          path="/reset-password/:token"
          element={<ResetPassword />}
        />
        <Route key={401} path="" element={<DashboardRoutes />}>
          {routes() && routes().length > 0
            ? routes().map((data, index) => (
                <Route
                  key={index}
                  path={data?.path}
                  element={<ProtectedRoute>{data?.element}</ProtectedRoute>}
                />
              ))
            : null}
          <Route
            key={501}
            path="/change-password"
            element={
              <ProtectedRoute>
                <ChangePassword />
              </ProtectedRoute>
            }
          />
        </Route>
      </Routes>
    </>
  );
};
export default Routing;
